var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 12,
    viewBox: "0 0 27 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 12,
    rx: 3,
    fill: "#4791FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45037 9H2.51855L4.6123 3.18182H5.62651L7.72026 9H6.78844L5.14355 4.23864H5.0981L3.45037 9ZM3.60662 6.72159H6.62935V7.46023H3.60662V6.72159ZM11.9819 3.18182H12.8626V7.00852C12.8626 7.41572 12.767 7.77652 12.5757 8.09091C12.3844 8.40341 12.1155 8.64962 11.7689 8.82955C11.4223 9.00758 11.016 9.09659 10.5501 9.09659C10.0861 9.09659 9.6808 9.00758 9.3342 8.82955C8.98761 8.64962 8.71867 8.40341 8.52739 8.09091C8.3361 7.77652 8.24045 7.41572 8.24045 7.00852V3.18182H9.1183V6.9375C9.1183 7.20076 9.17606 7.43466 9.29159 7.6392C9.40902 7.84375 9.57474 8.00473 9.78875 8.12216C10.0028 8.23769 10.2566 8.29545 10.5501 8.29545C10.8456 8.29545 11.1003 8.23769 11.3143 8.12216C11.5302 8.00473 11.695 7.84375 11.8086 7.6392C11.9242 7.43466 11.9819 7.20076 11.9819 6.9375V3.18182ZM15.7024 9H13.8189V3.18182H15.7621C16.3321 3.18182 16.8217 3.2983 17.2308 3.53125C17.6399 3.76231 17.9534 4.0947 18.1712 4.52841C18.3909 4.96023 18.5007 5.47822 18.5007 6.08239C18.5007 6.68845 18.3899 7.20928 18.1683 7.64489C17.9486 8.08049 17.6304 8.41572 17.2138 8.65057C16.7971 8.88352 16.2933 9 15.7024 9ZM14.6967 8.23295H15.6541C16.0973 8.23295 16.4657 8.14962 16.7592 7.98295C17.0528 7.81439 17.2725 7.57102 17.4183 7.25284C17.5642 6.93277 17.6371 6.54261 17.6371 6.08239C17.6371 5.62595 17.5642 5.23864 17.4183 4.92045C17.2744 4.60227 17.0594 4.3608 16.7734 4.19602C16.4875 4.03125 16.1323 3.94886 15.7081 3.94886H14.6967V8.23295ZM20.1502 3.18182V9H19.2723V3.18182H20.1502ZM20.8216 3.9375V3.18182H25.3245V3.9375H23.5091V9H22.6341V3.9375H20.8216Z",
    fill: "#4791FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.3708f5310631da4d8e9c45faaa45a75f.svg";
export { ForwardRef as ReactComponent };